export type FlightStatusType = 'landed' | 'en route' | 'cancelled' | 'delayed' | 'scheduled' | 'unknown';

const normalizeFlightStatus = (status?: string) => status?.trim().toLowerCase().replace(/[\s_-]+/g, '') || '';

export function getFlightStatusType(status?: string): FlightStatusType {
  switch (normalizeFlightStatus(status)) {
    case 'arrived':
    case 'landed':
      return 'landed';

    case 'enroute':
    case 'departed':
    case 'approaching':
      return 'en route';

    case 'canceled':
    case 'cancelled':
    case 'canceleduncertain':
    case 'cancelleduncertain':
      return 'cancelled';

    case 'delayed':
      return 'delayed';

    case 'expected':
    case 'scheduled':
    case 'checkin':
    case 'boarding':
    case 'gateclosed':
      return 'scheduled';

    default:
      return 'unknown';
  }
}

export function formatFlightStatus(status?: string): string {
  switch (getFlightStatusType(status)) {
    case 'landed':
      return 'Đã hạ cánh';
    case 'en route':
      return 'Đang bay';
    case 'cancelled':
      return 'Đã bị huỷ';
    case 'delayed':
      return 'Bị hoãn';
    case 'scheduled':
      return 'Đã lên lịch';
    default:
      return status?.trim() || 'Không xác định';
  }
}
